module.exports = "../dist/img/white-40.2f1a.jpg";